import React, { useState } from 'react';
import axios from 'axios';
import { toast } from '../../lib/toast';
import OtpBoxInput from './OtpBoxInput';

const API = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

export const MandatoryEmailVerificationGate = ({ user, onVerified, onLogout }) => {
  const [step, setStep] = useState('intro'); // 'intro' | 'code'
  const [challengeId, setChallengeId] = useState('');
  const [maskedEmail, setMaskedEmail] = useState('');
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);
  const [error, setError] = useState('');

  const token = localStorage.getItem('token');
  const authHeaders = { Authorization: `Bearer ${token}` };

  const sendCode = async () => {
    setLoading(true);
    setError('');
    try {
      const res = await axios.post(`${API}/api/auth/email/request-verification`, { email: user.email }, { headers: authHeaders });
      setChallengeId(res.data.challenge_id);
      setMaskedEmail(res.data.masked_email);
      setStep('code');
    } catch (err) {
      setError(err.response?.data?.detail || 'تعذّر إرسال رمز التحقق');
    } finally {
      setLoading(false);
    }
  };

  const resendCode = async () => {
    setResendLoading(true);
    setError('');
    try {
      await axios.post(`${API}/api/auth/email/resend-verification`, { challenge_id: challengeId }, { headers: authHeaders });
      toast.success('تم إرسال رمز جديد');
    } catch (err) {
      setError(err.response?.data?.detail || 'تعذّر إعادة إرسال الرمز');
    } finally {
      setResendLoading(false);
    }
  };

  const confirmCode = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await axios.post(`${API}/api/auth/email/confirm-verification`, { challenge_id: challengeId, code }, { headers: authHeaders });
      const updatedUser = { ...user, email_verified: true };
      localStorage.setItem('user', JSON.stringify(updatedUser));
      toast.success('تم توثيق بريدك الإلكتروني بنجاح، مرحباً بك في تسيار');
      if (onVerified) onVerified(updatedUser);
    } catch (err) {
      setError(err.response?.data?.detail || 'رمز غير صحيح');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div dir="rtl" className="fixed inset-0 z-[1000] flex items-center justify-center bg-[#0A192F] p-4" data-testid="mandatory-email-verification-gate">
      <div className="w-full max-w-md rounded-2xl bg-white p-7 shadow-2xl">
        <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-teal-50 text-teal-600">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} className="h-7 w-7">
            <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 6.75c0-.414.336-.75.75-.75h18a.75.75 0 01.75.75v10.5a.75.75 0 01-.75.75H3a.75.75 0 01-.75-.75V6.75zm.75-.75l9 6 9-6" />
          </svg>
        </div>
        <h2 className="text-center text-lg font-bold text-[#0A192F]">خطوة أخيرة لتفعيل حساب منشأتك</h2>
        <p className="mt-1.5 text-center text-sm text-slate-500">
          {step === 'intro'
            ? <>وثّق بريدك الإلكتروني <span dir="ltr" className="font-semibold text-slate-700">{user?.email}</span> لتتمكن من الوصول إلى لوحة تحكم منشأتك.</>
            : `أدخل الرمز المرسل إلى ${maskedEmail}`}
        </p>

        {error && (
          <div className="mt-4 rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-xs text-red-600" data-testid="mandatory-email-verification-error">
            {error}
          </div>
        )}

        {step === 'intro' ? (
          <button
            type="button"
            onClick={sendCode}
            disabled={loading}
            data-testid="mandatory-email-verification-send-button"
            className="mt-6 h-12 w-full rounded-xl bg-teal-600 text-sm font-bold text-white disabled:opacity-50"
          >
            {loading ? 'جارٍ الإرسال...' : 'إرسال رمز التحقق'}
          </button>
        ) : (
          <form onSubmit={confirmCode} className="mt-6 space-y-4">
            <OtpBoxInput length={6} value={code} onChange={setCode} autoFocus testIdPrefix="mandatory-email-verify-code" />
            <button
              type="submit"
              disabled={loading || code.length !== 6}
              data-testid="mandatory-email-verification-confirm-button"
              className="h-12 w-full rounded-xl bg-teal-600 text-sm font-bold text-white disabled:opacity-50"
            >
              {loading ? 'جارٍ التحقق...' : 'تأكيد التوثيق'}
            </button>
            <button
              type="button"
              onClick={resendCode}
              disabled={resendLoading}
              data-testid="mandatory-email-verification-resend-button"
              className="w-full text-center text-xs font-semibold text-teal-600 hover:text-teal-700 disabled:opacity-50"
            >
              {resendLoading ? 'جارٍ الإرسال...' : 'لم يصلك الرمز؟ إعادة الإرسال'}
            </button>
          </form>
        )}

        <button
          type="button"
          onClick={onLogout}
          data-testid="mandatory-email-verification-logout-button"
          className="mt-5 w-full text-center text-xs font-medium text-slate-400 hover:text-slate-600"
        >
          تسجيل الخروج
        </button>
      </div>
    </div>
  );
};
